<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import {
  ONE_OFF_CAMPAIGN_EMPTY_STATE_CONTENT,
  localizeCampaignContent,
} from './CampaignEmptyStateContent';

import EmptyStateLayout from 'dashboard/components-next/EmptyStateLayout.vue';
import CampaignCard from 'dashboard/components-next/Campaigns/CampaignCard/CampaignCard.vue';

defineProps({
  title: {
    type: String,
    default: '',
  },
  subtitle: {
    type: String,
    default: '',
  },
});

const { tm } = useI18n();

const campaigns = computed(() =>
  localizeCampaignContent(
    ONE_OFF_CAMPAIGN_EMPTY_STATE_CONTENT,
    tm('EMPTY_STATE_BACKDROP.CAMPAIGNS')
  )
);
</script>

<template>
  <EmptyStateLayout :title="title" :subtitle="subtitle">
    <template #empty-state-item>
      <div class="flex flex-col gap-4 p-px">
        <CampaignCard
          v-for="campaign in campaigns"
          :key="campaign.id"
          :title="campaign.title"
          :message="campaign.message"
          :is-enabled="campaign.enabled"
          :status="campaign.campaign_status"
          :sender="campaign.sender"
          :inbox="campaign.inbox"
          :scheduled-at="campaign.scheduled_at"
        />
      </div>
    </template>
  </EmptyStateLayout>
</template>
